import styled from 'styled-components';

const Contenedor = styled.div`
  width: 100%;
  height: auto;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const Terminos = styled.div`
  width: 70%;
`;

const H1 = styled.h1`
  padding-top: 40px !important;
  text-align: center;
  padding-bottom: 30px !important;
  font-size: 40px;
  font-family: "Raleway", sans-seriff;

  @media screen and (max-width: 1024px) {
      padding-top: 80px !important;
  }
`;

const P = styled.p`
  margin-bottom: 20px !important;
  font-size: 18px;
  text-align: justify;
  font-family: "Raleway", sans-seriff;
`;

const Ps = styled.p`
  margin-bottom: 20px !important;
  font-size: 18px;
  text-align: justify;
  padding-left: 30px !important;
  font-family: "Raleway", sans-seriff;
`;

const Ul = styled.ul`
  // list-style: none;
  padding-left: 30px !important;

  li {
      padding-left: 30px !important;
      font-weight: 600;
      font-size: 18px;
      margin-bottom: 20px !important;
      font-family: "Raleway", sans-seriff;
  }
`;

export {
  Contenedor,
  Terminos,
  H1,
  P,
  Ps,
  Ul
}